<template>
  <div>
    
      <v-row style="margin-left:20px;margin-right:20px;">
          <v-col md="2"></v-col>
        <v-col md="8"  style="margin-top:10px;margin-bottom:10px;">
          <v-card  height="100%" class="mx-auto">
            <v-card-title class="prfont justify-center">My WishList({{len}})</v-card-title>
            <div v-for="i in prodata">
              <hr />
              <!-- <h4 style="color:black;"><strong>{{i.product.productname}}</strong></h4> -->
              <v-card-text>
                  <router-link :to="'/Product/'+i._id" style="color:black;;">
                <v-row>
                  <v-col md="3">
                    <v-col md="12">
                    <v-card class="jj">
                    <v-img :src="'https://api.inguzsales.in/u/'+i.product.photos[0]" style="width:100%;height:100%;object-fit:cover;" />
                    </v-card>
                    </v-col>
                  </v-col>
                  <v-col md="9" style="padding-top:20px;">
                    <span style="color:black;font-size:20px;">
                      <router-link :to="'/Product/'+i._id"><strong class="prfont">{{i.product.productname}}</strong></router-link>
                    </span>
                    <span style="float:right;"><v-icon @click="deleteReviews(i)">mdi-delete</v-icon></span>
                    <br />
                    <span>{{i.product.description.slice(0,150)}}.....</span>&nbsp;
                    <!-- <span>Reviews</span> -->
                    <br />
                    <h3 style="color:black;">
                      <strong class="prfont">₹ {{i.product.price}}</strong>
                    </h3>
                  
                    <br/>
                    <!-- <span>Stock Detail</span> -->
                      <v-layout>
                      <v-flex >
                        <span >
                          <h3 style="color:black;">
                          
                            <strong @click="RemoveCart" class="prfont fontsp"><a style="color:black;">REMOVE</a></strong>
                          </h3>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-col>
                </v-row>
               </router-link>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
        <v-col md="2"></v-col>
      </v-row>
    
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  props: ["id"],
  components: {
    StarRating
  },
  data() {
    return {
      len: "",
      shipp:"",
      prodata: [],
      total: "",
      subtotal: "",

      tottax: ""
    };
  },
  mounted: function() {
    this.getProduct();
    this.getProducts();
    this.UpdateCart();
  },
  methods: {
    RemoveCart() {
      var data = {};
      data["productid"] = this.id;

      axios({
        method: "POST",
        url: "/WishList/Remove",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
          .then(response => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
           
            this.$dlg.alert(
              this.msg,
              () => {
               
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getProduct() {
      axios({
        method: "GET",
        url: "/WishList/all",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.prodata = Response.data.wishlist;
        this.len = Response.data.wishlist.length;
        this.total =  Math.round(Response.data.total);
        this.subtotal = Math.round( Response.data.subtotal);
        this.tottax = Math.round(Response.data.totaltax);
        this.shipp= Math.round(Response.data.shippingcharge);
        // console.log(Response);
      });
    }
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}
.by{
      width: 28px;
    height: 28px;
    background: linear-gradient(#fff,#f9f9f9);
    display: inline-block;
    border: 1px solid #c2c2c2;
    cursor: pointer;
    font-size: 16px;
    border-radius: 50%;
    padding-top: 1px;
    line-height: 1;
}
.bu{
      width: 28px;
    height: 28px;
    background: linear-gradient(#fff,#f9f9f9);
    display: inline-block;
    border: 1px solid #c2c2c2;
    cursor: pointer;
    font-size: 16px;
   
    padding-top: 1px;
    line-height: 1;
}
.jj{
 
  height:146px;
  width:143px;
}
</style>